import React, { useState, useContext, useEffect } from "react";
import MainMenu from '../../Pages/RE/ReMainMenu'
import Card from '../../Components/RE/ReListCard/Card'
import Table from '../../Components/RE/AllTableComponent'
import RefineSearch from '../../Components/RefineSearchComponent'
import ReLayout from '../../Components/ReLayout'
import Constants from '../../Constants'
import { useLocation } from "react-router";
import { reExportPDF } from "../../Config/config";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import ReExitRefineSearch from '../../Components/RefineSearch/ReExitRefineSearch'
import {reExitExportData ,Data} from "../../Components/ExportPopup/ExportData"
import ExportPopup from "../../Components/ExportPopup";
import FilterTag from "../../Components/Tag";
import { UserContext } from "../../Contexts/UserContext";
import ExcelDownloader from "../../Components/shared/ExcelDownloader";
import { TableDataContext } from "../../Contexts/TableDataContext";
import { Tooltip } from "antd";
import { RiMailDownloadLine } from "react-icons/ri";
import DownloadTrigger from "../../Components/ExportPopup/DownloadTrigger";

/**
 * The `REExists` function is a React component that renders a page for displaying and filtering real
 * estate exit data.
 * @param props - The `props` parameter is an object that contains the properties passed to the
 * `REExists` component. These properties can be accessed using dot notation, such as `props.active` or
 * `props.someProperty`.
 * @returns a JSX element.
 */
function REExists(props) {
    const [showPopup, setShowPopup] = useState(false);
    const {save, setSave,refineSearchFilters ,groupId} = useContext(PeFilterContext);
    const { globalSearchResult } = useContext(TableDataContext);
    const [openTab, setOpenTab] = React.useState(1);
    const savedList = () => {
        setSave(!save)
    }
    useEffect(() => {
        setOpenTab(props.active)
    }, [openTab])
    const {isStudent,isTrialExport} = useContext(UserContext)

    const location = useLocation();
    const { pathname } = useLocation(); 

    return (
        <>
            <ReLayout>
                <div className="flex min-h-screen h-screen flex-col">
                    <div className="flex min-h-0 flex-1 overflow-hidden">                       
                        <main className={`min-w-0 mt-14 flex-1 border-t border-gray-200 flex `}>
                            <section className="flex h-full min-w-0 flex-1 flex-col lg:order-last bg-[#EDEDED]">
                                <div></div>
                                <div className="pl-3 pr-4 lg:pr-4 md:pr-[0.7rem]">
                                    <div className="scrollbar ">
                                        <div className="px-2  md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between  ">
                                                <div></div>                                            
                                            <div className="flex justify-between items-center px-5 lg:px-2 py-2">
                                                    <div></div>
                                                    <div className="flex items-center ">
                                                    {isStudent == 'true' || groupId?.myList?.length >0  ?  <></> : <>
                                                            <button className="px-3">
                                                                        {
                                                                        isTrialExport=='false' ?
                                                                            <ExcelDownloader
                                                                            url={reExportPDF}
                                                                            fileName={Constants.exportNames.re_company_exit}
                                                                            data={{"type" : "re-exits"}}  
                                                                            children={
                                                                                <DownloadTrigger />
                                                                            }                   
                                                                            />
                                                                            :
                                                                            <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                                                                        }
                                                            
                                                                {showPopup && (
                                                                    <ExportPopup
                                                                        modules="re-company"
                                                                        fileName={Constants.exportNames.re_company_exit}
                                                                        url={reExportPDF}
                                                                        onClose={() => setShowPopup(false)}
                                                                        exportOptions={reExitExportData }
                                                                        type="re-exits"
                                                                    />

                                                                )}
                                                            </button>
                                                        </> }
                                                    </div>
                                                </div>
                                            
                                    </div>
                                </div>
                            </div>
                            <div className='overflow-y-auto'>
                                <Table menu="re-exit" sub_type_master_id={Constants.subCategoryIds.re_exitsma_id}/>
                            </div>
                        </section>
                    </main>
                </div>
                <br />

            </div>
            {/* </Layout> */}
        </ReLayout>
        </>
    )
}

export default REExists
